import styled from 'styled-components';

export const WrapperSider = styled.div`
  height: 100vh;
  display: flex;
  align-items: stretch;
  overflow-x: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

export const WrapperHeader = styled.div`
  height: auto;
  overflow: hidden;
  width: 100%;
`;

export const ContentSider = styled.div`
  display: flex;
  flex-direction: column;
  place-content: center;
  align-items: center;
  width: 20vw;
  max-width: 390px;

  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }
`;

export const ContentHeader = styled.div`
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;
`;

export const Background = styled.div`
  flex: 1;
  width: 100%;
  max-width: 100vw;
  overflow-x: hidden;

  @media (max-width: 768px) {
    margin-left: 0;
  }
`;
